import { gql } from '@apollo/client';

export const downloadImageQuery = gql`
  query ($imageKey: String!) {
    downloadImage(imageKey: $imageKey) {
      base64Data
    }
  }
`;
